import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  LinearProgress,
} from "@mui/material";
import FeatureSectionEditor from "./FeatureSectionEditor";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export default function PageEditor() {
  const { slug } = useParams();
  const [page, setPage] = useState({});
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingS, setIsLoadingS] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const UpdateSections = async () => {
    setIsLoadingS(true);
    const url = `${api_Routes.Pages.Edit}/${slug}`;
    const { response } = await Helper.Post({
      url,
      hasToken: true,
      data: { sections: sections },
    });
    if (response) {
      setShouldRefresh(!shouldRefresh);
    }
    setIsLoadingS(false);
  };
  const handleSave = () => {
    UpdateSections();
  };
  useEffect(() => {
    const getPage = async () => {
      setIsLoading(true);
      const url = `${api_Routes.Pages.View}/${slug}`;
      const { response } = await Helper.Get({
        url,
        hasToken: true,
      });
      if (response) {
        setPage(response);
        setSections(response.sections);
      }
      setIsLoading(false);
    };
    getPage();
  }, [shouldRefresh]);

  if (isLoading) {
    return <LinearProgress />;
  }
  console.log(sections);
  return (
    <Container>
      <Typography variant="h4">Edit {page?.title}</Typography>
      {sections?.map((sec, i) => (
        <div key={sec.id || i} style={{ marginTop: 24 }}>
          {sec.type === "text" ? (
            <>
              {" "}
              {/* Text section: separate title and description */}
              <TextField
                fullWidth
                label="Title"
                value={sec.content?.heading || ""}
                onChange={(e) => {
                  const newSecs = [...sections];
                  newSecs[i].content = {
                    ...newSecs[i].content,
                    heading: e.target.value,
                  };
                  setSections(newSecs);
                }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                multiline
                label="Description"
                value={sec.content?.body || ""}
                onChange={(e) => {
                  const newSecs = [...sections];
                  newSecs[i].content = {
                    ...newSecs[i].content,
                    body: e.target.value,
                  };
                  setSections(newSecs);
                }}
                sx={{ mb: 2 }}
              />
              {sec.content?.heading === "Our Company" && (
                <TextField
                  fullWidth
                  multiline
                  label="Footer"
                  value={sec.content?.footer || ""}
                  onChange={(e) => {
                    const newSecs = [...sections];
                    newSecs[i].content = {
                      ...newSecs[i].content,
                      footer: e.target.value,
                    };
                    setSections(newSecs);
                  }}
                />
              )}
            </>
          ) : (
            <FeatureSectionEditor
              title={page?.title === "About Us" ? "Our Features" : "Our Terms"}
              section={sec}
              onChange={(features) => {
                const newSecs = [...sections];
                newSecs[i].features = features;
                setSections(newSecs);
              }}
              ChangeContent={(desc) => {
                const newSecs = [...sections];
                newSecs[i].content = {
                  ...newSecs[i].content,
                  body: desc,
                };
                setSections(newSecs);
              }}
            />
          )}
        </div>
      ))}
      <Button variant="contained" sx={{ mt: 4 }} onClick={handleSave}>
        {isLoadingS ? "Saving..." : "Save Changes"}
      </Button>
    </Container>
  );
}
